<template>
    <div id="accordion">
        <div class="card najiz-card-panel mb-3">
            <div class="card-header najiz-panel-header" id="contract-details-heading">
                <a class="text-dark" data-toggle="collapse" href="#contract-details-collapse" role="button" aria-expanded="false"
                   aria-controls="contract-details-collapse">
                    <h4 class="mb-0 py-3">
                        <i class="fal fa-angle-up rotate-icon fa-lg ml-5"></i>
                        <b>
                            تفاصيل العقد
                        </b>
                    </h4>
                </a>
            </div>

            <div id="contract-details-collapse" class="collapse show" aria-labelledby="contract-details-heading" data-parent="#accordion">
                <div class="card-body" v-if="contractDetails">
                    <h5 v-if="contractDetails.introductionLabel && contractDetails.introductionLabel != '<p><br></p>'">
                        <u>المقدمة</u>:
                    </h5>
                    <br />
                    <p v-if="contractDetails.introductionLabel && contractDetails.introductionLabel != '<p><br></p>'"
                       id="introduction" v-html="contractDetails.introductionLabel"></p>
                    <h5 v-if="contractDetails.preliminaryText && contractDetails.preliminaryLabel != '<p><br></p>'">
                        <u>تمهيد</u>:
                    </h5>
                    <p v-if="contractDetails.preliminaryText && contractDetails.preliminaryLabel != '<p><br></p>'" id="preliminary"
                       v-html="contractDetails.preliminaryText"></p>
                    <div v-for="(clause, masterIndex) in contractDetails.clauses" :key="masterIndex">
                        <div class="mb-5 h-100">
                            <div class="pb-0">
                                <p>
                                    <u><b>  {{ clause.clauseName }}</b></u>
                                </p>
                                <p v-if="clause.clauseDescription">{{ clause.clauseDescription }}</p>
                                <ul style="margin-right:10px;">
                                    <li v-for="(textItem, index) in clause.childClauses" :key="textItem.id">
                                        <div class="w-100 ">
                                            <p dir="rtl">
                                                {{ index + 1 + ' - ' }}
                                                <span v-html="textItem.labelText"></span>
                                            </p>
                                            <ul class="pr-7 pt-1">
                                                <li v-for="(subTextItem, subIndex) in  textItem.childClauses" :key="subTextItem.id">
                                                    <p>
                                                        {{ subIndex | getIndexedLetter }} -
                                                        <span v-html="subTextItem.labelText"></span>
                                                    </p>
                                                </li>
                                            </ul>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script lang="ts">
    import { Component, Vue, Prop } from 'vue-property-decorator';

    import { ContractDetails } from '@/models/contract.model';

    @Component
    export default class ContractTextComponent extends Vue {
        @Prop({ required: true }) contractDetails!: ContractDetails;
    }
</script>

<style>

    .v-application p {
        margin-bottom: 5px !important;
    }
</style>